/* RESPONSIBLE TEAM: team-standalone */
import ApplicationAdapter from '../application';

export default class IntegrationAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'standalone/integrations';
  }
}
